<script>
  import { M } from '../../external';

  export let settings = {},
    previewAnswers = {},
    onApprove = () => {},
    onReject = () => {};

  let questions = settings.questions;
  let title = settings.title;
  let description = settings.description;
</script>

<div class="preview-mode">
  <div class="preview-header">
    {#if title}
      <div class="preview-title">{@html title}</div>
    {/if}
    {#if description}
      <div class="preview-description">{@html description}</div>
    {/if}
  </div>

  <div class="preview-questions">
    {#each questions as question (question.id)}
      <div class="preview-question">
        <label for={question.id}>
          {@html question.label}
          {#if question.required}
            <span class="required">*</span>
          {/if}
        </label>

        {#if question.type === 'text'}
          <input
            disabled={true}
            id={question.id}
            type="text"
            bind:value={previewAnswers[question.id]}
            placeholder="Enter your answer" />
        {:else if question.type === 'multiline'}
          <textarea
            disabled={true}
            id={question.id}
            bind:value={previewAnswers[question.id]}
            placeholder="Enter your answer"
            rows="4"></textarea>
        {:else if question.type === 'select'}
          <select disabled={true} id={question.id} bind:value={previewAnswers[question.id]}>
            <option value="">Select an option</option>
            {#each question.options as option}
              <option value={option}>{option}</option>
            {/each}
          </select>
        {:else if question.type === 'radio'}
          <div class="radio-options" role="radiogroup">
            {#each question.options as option, i}
              <label class="radio-label" for={`${question.id}-radio-${i}`}>
                <input
                  disabled={true}
                  id={`${question.id}-radio-${i}`}
                  type="radio"
                  bind:group={previewAnswers[question.id]}
                  value={option} />
                {option}
              </label>
            {/each}
          </div>
        {:else if question.type === 'checkbox'}
          <div class="checkbox-options">
            {#each question.options as option, i}
              <label class="checkbox-label" for={`${question.id}-checkbox-${i}`}>
                <input
                  disabled={true}
                  id={`${question.id}-checkbox-${i}`}
                  type="checkbox"
                  bind:group={previewAnswers[question.id]}
                  value={option} />
                {option}
              </label>
            {/each}
          </div>
        {/if}
      </div>
    {/each}
  </div>
  <div class="col20 f-left mt-10">
    <a class="middle-button blue mr-5" on:click={onApprove}>{M.APPROVE}</a>
    <a class="middle-button gray" on:click={onReject}>{M.DENY}</a>
  </div>
</div>

<style>
    .preview-mode {
    padding: 35px;
  }

  .preview-mode h3 {
    margin: 0 0 8px 0;
    color: #333;
  }

  .preview-mode p {
    color: #666;
    margin: 0 0 24px 0;
  }

  .preview-header {
    margin-bottom: 32px;
    text-align: center;
  }

  .preview-title {
    margin: 0 0 16px 0;
    font-size: 1.8em;
    color: #333;
  }

  .preview-description {
    margin: 0;
    color: #666;
    font-size: 1.1em;
    line-height: 1.5;
  }

  .preview-questions {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .preview-question {
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .preview-question label {
    font-weight: 500;
    color: #333;
    float: left;
  }

  .preview-question > label {
    font-size: 15px;
  }

  .preview-question .radio-options,
  .preview-question .checkbox-options {
    margin-top: 6px;
    float: left;
    width: 100%;
  }


  .required {
    color: #ff5252;
    margin-left: 4px;
  }

  .preview-question input[type='text'],
  .preview-question textarea,
  .preview-question select {
    padding: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    font-size: 1em;
    width: 100%;
    box-sizing: border-box;
    float: left;
    width: 100%;
  }

  .preview-question textarea {
    resize: vertical;
    min-height: 100px;
  }

  .radio-options,
  .checkbox-options {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .radio-label,
  .checkbox-label {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: normal;
    cursor: pointer;
  }

  .radio-label input,
  .checkbox-label input {
    margin: 0;
  }

  .validation-error {
    color: #ff5252;
    font-size: 0.9em;
    margin-top: 4px;
  }

  button {
    padding: 8px 16px;
    border-radius: 4px;
    border: none;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
  }

  button:hover:not(:disabled) {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }

  button:active:not(:disabled) {
    transform: translateY(0);
  }

  button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }

  .save-btn {
    background: #4caf50;
    color: white;
  }

  .save-btn:hover:not(:disabled) {
    background: #43a047;
  }
</style>
